import React from 'react';
const Version = () => {

    return (
        <p style={{ fontSize: 14 }}>version 2.1</p>
    )
}

export default Version;